import apiMiddleware from "../api/apiMiddleware";

const list = async (page = 1, search = "") => {
  const params = new URLSearchParams({ page });

  if (search?.trim()) {
    params.append("search", search.trim());
  }

  const response = await apiMiddleware.get(
    `/hotel-supplier-master?${params.toString()}`
  );
  return response.data;
};

const addHotel = async (formData) => {
  // formData should be a FormData object for file uploads
  const response = await apiMiddleware.post(
    "/hotel-supplier-master",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};

const updateHotel = async (id, formData) => {
  // formData should be a FormData object for file uploads
  const response = await apiMiddleware.post(
    `/hotel-supplier-master/${id}?_method=PUT`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return response.data;
};

const deleteHotel = async (id) => {
  const response = await apiMiddleware.delete(`/hotel-supplier-master/${id}`);
  return response.data;
};

export { list, addHotel, updateHotel, deleteHotel };
